<template>
<div class="suggestion-reply">
    <UserProfile :user="user" :date="reply.createdAt"/>
    <div class="pre-wrap-text">{{ reply.text }}</div>
</div>
</template>

<script>
import UserProfile from '@/components/UserProfile'

export default {
    name: 'SuggestionReply',
    props: {
        user: Object,
        reply: Object,
    },
    components: {
        UserProfile
    }
}
</script>

<style lang="scss" scoped>
.suggestion-reply {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 0.5rem;
    overflow: hidden; // wrap long text
}

.user-profile {
    margin-bottom: 10px;
}
</style>
